export const POSTS = [
  {
    slug: "aparecer-en-google-maps-negocios-locales",
    title: "Cómo aparecer en Google Maps: guía rápida para negocios locales",
    excerpt: "El 80% de los clientes locales buscan en Google antes de visitar un negocio. Así se optimiza una ficha de Google Business para salir primero en tu ciudad.",
    category: "Google Business",
    date: "2026-09-01",
    readTime: "4 min",
    sections: [
      {
        h: "Tu ficha de Google es tu nuevo escaparate",
        p: [
          "Antes de llamarte, tus clientes te buscan en Google. Una ficha de Google Business completa y activa es la diferencia entre aparecer en el mapa o ser invisible.",
          "Rellena absolutamente todos los campos: horarios, servicios, atributos, descripción con palabras clave de tu ciudad y tu sector, y enlace a tu web o WhatsApp.",
        ],
      },
      {
        h: "Las reseñas mandan (y hay que responderlas)",
        p: [
          "Google premia los negocios con más reseñas recientes y mejor valoradas. Pide una reseña a cada cliente satisfecho: con un enlace directo es cuestión de 30 segundos.",
          "Responder a todas las reseñas, también a las malas, demuestra profesionalidad y mejora tu posicionamiento local.",
        ],
      },
      {
        h: "Fotos y publicaciones: señales de vida",
        p: [
          "Una ficha con fotos recientes del local, los productos y el equipo genera mucha más confianza y recibe más clics.",
          "Publicar novedades, ofertas o eventos cada semana le dice a Google que tu negocio está activo, y eso se traduce en mejores posiciones.",
        ],
      },
      {
        h: "¿No tienes tiempo? Delega",
        p: [
          "Optimizar y mantener una ficha lleva constancia. En Socify Marketing lo hacemos por ti: optimización completa, publicaciones, fotos y respuestas a reseñas desde 190 €/mes.",
        ],
      },
    ],
  },
  {
    slug: "senales-negocio-necesita-tienda-online",
    title: "5 señales de que tu negocio necesita una tienda online",
    excerpt: "Vender por WhatsApp está bien para empezar, pero hay un momento en el que se queda pequeño. Estas son las señales de que ha llegado la hora de tu e-commerce.",
    category: "E-commerce",
    date: "2026-08-20",
    readTime: "5 min",
    sections: [
      {
        h: "1. Repites lo mismo 20 veces al día",
        p: [
          "Precios, tallas, disponibilidad, envíos… Si pasas el día respondiendo las mismas preguntas por WhatsApp, una tienda online con catálogo claro te devuelve esas horas.",
        ],
      },
      {
        h: "2. Pierdes ventas fuera de tu horario",
        p: [
          "Tu tienda física cierra, pero internet no. Una tienda online vende mientras duermes: el cliente elige, paga y tú solo preparas el pedido.",
        ],
      },
      {
        h: "3. Tus clientes te preguntan si tienes web",
        p: [
          "Cuando un cliente potencial no encuentra tu tienda online, compra en la de tu competencia. Tener e-commerce propio ya es una cuestión de confianza.",
        ],
      },
      {
        h: "4. Quieres vender fuera de tu ciudad",
        p: [
          "Con Shopify o WooCommerce tu mercado pasa de tu barrio a todo el país (o más). Los envíos y pagos se gestionan solos con las pasarelas adecuadas.",
        ],
      },
      {
        h: "5. Las redes sociales te traen tráfico que no convierte",
        p: [
          "Si tus publicaciones generan interés pero las ventas se enredan en mensajes, necesitas un embudo: publicación → tienda → pedido. Sin fricción.",
          "En Socify Marketing montamos tu tienda completa (diseño, catálogo, pagos y optimización móvil) desde 890 €, pago único.",
        ],
      },
    ],
  },
  {
    slug: "que-publicar-instagram-negocio-local",
    title: "Qué publicar en Instagram si tienes un negocio local",
    excerpt: "No hace falta volverse loco creando contenido. Con 3 publicaciones semanales bien pensadas y un par de Reels, tu negocio local puede brillar en Instagram.",
    category: "Redes sociales",
    date: "2026-08-05",
    readTime: "4 min",
    sections: [
      {
        h: "La regla de oro: constancia antes que perfección",
        p: [
          "El algoritmo premia las cuentas activas. Tres publicaciones por semana y stories a diario funcionan mejor que diez posts un mes y silencio el siguiente.",
          "Un calendario de contenido mensual te quita la presión de improvisar cada día.",
        ],
      },
      {
        h: "Contenido que funciona en negocios locales",
        p: [
          "Producto en acción: tu plato estrella saliendo de la cocina, el antes y después de un trabajo, el producto nuevo llegando a tienda.",
          "Personas: tú, tu equipo, tus clientes (con permiso). La gente conecta con personas, no con logos.",
          "Prueba social: capturas de reseñas, clientes contentos, pedidos saliendo. Nada vende como ver que otros ya confían.",
        ],
      },
      {
        h: "Reels: tu megáfono gratuito",
        p: [
          "Los Reels llegan a gente que aún no te sigue. Con uno o dos a la semana, usando audios en tendencia y mostrando tu día a día, multiplicas tu alcance sin pagar publicidad.",
        ],
      },
      {
        h: "Responder es vender",
        p: [
          "Cada comentario y cada mensaje directo es un cliente llamando a tu puerta. Responder rápido marca la diferencia entre una venta y un cliente perdido.",
          "¿Te quita demasiado tiempo? Nuestro servicio de Community Manager (390 €/mes, sin permanencia) incluye publicaciones, Reels, stories y respuesta a mensajes.",
        ],
      },
    ],
  },
  {
    slug: "cuanto-cuesta-un-logo-espana",
    title: "Cuánto cuesta un logo en España: guía de precios sin trampas",
    excerpt: "Desde los 5 € de una web freelance hasta los 3.000 € de un estudio. Te explicamos qué incluye cada rango de precio y cómo no tirar el dinero.",
    category: "Diseño gráfico",
    date: "2026-09-10",
    readTime: "4 min",
    sections: [
      {
        h: "El logo de 5 € te saldrá caro",
        p: [
          "Un logo generado en cinco minutos con una plantilla no es tuyo: lo usan cientos de negocios, no puedes registrarlo como marca y no viene en los formatos que necesitas para imprimir o bordar.",
          "A los pocos meses toca rehacerlo, cambiar cartelería, perfiles y etiquetas. Eso cuesta mucho más que haberlo hecho bien desde el principio.",
        ],
      },
      {
        h: "Qué debe incluir un logo profesional",
        p: [
          "Archivos vectoriales (AI, SVG, PDF) que se pueden ampliar sin perder calidad, versiones para fondo claro y oscuro, y una mini guía con tus colores y tipografías.",
          "También es clave que sea un diseño original y registrable: es la cara legal de tu negocio.",
        ],
      },
      {
        h: "Rangos de precio reales en España",
        p: [
          "Plantillas y concursos online: 5–50 € (sin exclusividad ni archivos profesionales). Freelance junior: 100–300 €. Estudios y agencias: desde 300 € hasta varios miles con identidad completa.",
          "En Socify Marketing el diseño gráfico empieza en 250 € por pack, con archivos finales editables y todo listo para usar en redes, impresión y web.",
        ],
      },
      {
        h: "La pregunta correcta no es cuánto cuesta",
        p: [
          "Es cuánto te cuesta no tenerlo: un negocio con imagen descuidada transmite desconfianza antes de que el cliente pruebe tu producto. El logo es una inversión que trabaja para ti cada día.",
        ],
      },
    ],
  },
  {
    slug: "cuanto-invertir-en-marketing-negocio-pequeno",
    title: "Cuánto invertir en marketing si tienes un negocio pequeño",
    excerpt: "Ni cero ni un rimel. Te damos cifras concretas en euros para repartir tu presupuesto entre web, redes y Google sin ahogarte.",
    category: "Precios",
    date: "2026-09-12",
    readTime: "5 min",
    sections: [
      {
        h: "La regla del 5-10%",
        p: [
          "Los expertos recomiendan invertir entre el 5% y el 10% de tu facturación en marketing. Si tu negocio factura 5.000 € al mes, hablamos de 250–500 € mensuales.",
          "¿Aún no facturas? Entonces invierte en los cimientos primero: web, ficha de Google e imagen de marca. Son pagos únicos que duran años.",
        ],
      },
      {
        h: "Prioridades si el presupuesto es ajustado",
        p: [
          "Primero: una web sencilla con WhatsApp y formulario (desde 490 €, pago único) para que quien te busque te encuentre y te contacte.",
          "Segundo: tu ficha de Google Business optimizada (190 €/mes), porque el 80% de los clientes locales deciden ahí.",
          "Tercero: redes sociales gestionadas (390 €/mes) cuando ya tengas lo anterior funcionando y quieras acelerar.",
        ],
      },
      {
        h: "Lo que nunca debes recortar",
        p: [
          "La medición. Si no sabes de dónde vienen tus clientes, estás tirando dinero a ciegas. Pregunta siempre: ¿esto cuántos contactos o ventas me trae?",
          "Desconfía de quien te promete primeras posiciones en Google en una semana o miles de seguidores por 50 €. El marketing serio es constancia, no magia.",
        ],
      },
      {
        h: "Calcula tu caso concreto",
        p: [
          "Cada negocio es distinto. Usa la calculadora de presupuesto de nuestra web para estimar tu inversión en 10 segundos, o escríbenos por WhatsApp y te damos una propuesta cerrada en menos de 2 horas laborables.",
        ],
      },
    ],
  },
  {
    slug: "flyers-carteles-menus-diseno-impreso-vende",
    title: "Flyers, carteles y menús: el diseño impreso que aún vende",
    excerpt: "En la era de Instagram, un buen cartel en el escaparate o un menú cuidado siguen cerrando ventas. Claves para que tu material impreso trabaje para ti.",
    category: "Diseño gráfico",
    date: "2026-09-14",
    readTime: "4 min",
    sections: [
      {
        h: "Lo impreso no ha muerto: se ha vuelto selectivo",
        p: [
          "Tu cliente pasa por delante de tu escaparate, hoje tu carta y se lleva tu flyer. El material impreso bien diseñado refuerza todo lo que haces online.",
          "La clave es la coherencia: mismos colores, misma tipografía y mismo tono que tu Instagram y tu web. Marca reconocible al instante.",
        ],
      },
      {
        h: "Errores que espantan clientes",
        p: [
          "Textos ilegibles, fotos pixeladas de internet, siete tipografías distintas y precios sin actualizar. Un menú descuidado sugiere una cocina descuidada, te guste o no.",
          "Menos es más: una idea por pieza, jerarquía clara (qué miro primero, qué después) y una llamada a la acción visible: teléfono, WhatsApp o código QR.",
        ],
      },
      {
        h: "El QR: el puente entre el papel y tu WhatsApp",
        p: [
          "Un código QR en tu cartel o flyer lleva al cliente directo a tu WhatsApp, tu carta digital o tu Instagram en un segundo. Es la forma más barata de convertir papel en conversación.",
        ],
      },
      {
        h: "Packs de diseño sin sustos",
        p: [
          "En Socify Marketing diseñamos logos, flyers, carteles, menús y banners desde 250 € por pack, con archivos listos para imprenta y para redes. Escríbenos y te preparamos propuesta hoy mismo.",
        ],
      },
    ],
  },
  {
    slug: "septiembre-marketing-vuelta-al-trabajo",
    title: "Septiembre: el mes en que tu negocio puede adelantar a la competencia",
    excerpt: "Mientras otros negocios vuelven poco a poco de vacaciones, septiembre es el mejor momento para lanzar tu web, activar tus redes y preparar la recta final del año.",
    category: "Estrategia",
    date: "2026-09-14",
    readTime: "4 min",
    sections: [
      {
        h: "La vuelta es un botón de reinicio",
        p: [
          "En septiembre tus clientes vuelven a la rutina, miran el móvil con más atención y toman decisiones pospuestas: apuntarse al gym, reformar la casa, cenar fuera, comprar.",
          "El negocio que aparece primero en esas búsquedas se lleva el trimestre más fuerte del año: octubre, noviembre y diciembre.",
        ],
      },
      {
        h: "Revisa tu ficha de Google antes que nadie",
        p: [
          "Actualiza horarios, sube fotos nuevas y publica una oferta de vuelta al trabajo. Media hora de trabajo en tu ficha puede ponerte por delante de competidores que siguen de vacaciones digitales.",
        ],
      },
      {
        h: "Calienta tus redes para la campaña de otoño",
        p: [
          "Quien empieza a publicar en septiembre llega a Black Friday y Navidad con audiencia activa. Quien empieza en noviembre, llega tarde y caro.",
          "Tres publicaciones semanales y un par de Reels bastan para que el algoritmo te tenga en cuenta cuando llegue el momento de vender.",
        ],
      },
      {
        h: "¿Tu web aguanta la temporada?",
        p: [
          "Si tu web carga lenta en el móvil, no tiene botón de WhatsApp o nadie te escribe por el formulario, septiembre es el mes para arreglarlo.",
          "En Socify Marketing preparamos tu web, tus redes y tu Google Business para la recta final del año. Escríbenos por WhatsApp y en menos de 2 horas laborables tienes propuesta.",
        ],
      },
    ],
  },
];
